import React, { useState, useEffect } from "react";
import {
  ChakraProvider,
  Box,
  Card,
  Center,
  Flex,
  Text,
  Heading,
  VStack,
  SimpleGrid,
  Grid,
  GridItem,
  useColorModeValue,
} from "@chakra-ui/react";
import { Link, useNavigate } from "react-router-dom";
import { ColorModeSwitcher } from "../ColorModeSwitcher";
import { Nav } from "../containers/Nav";
import { Footer } from "../containers/Footer";
import { getAllCampaigns } from "../actions/campaigns";
import CampaignCard from "../components/campaignCard";
import { validateUserAuth } from "../helpers";

function Campaigns() {
  const navigate = useNavigate();
  const [userBrand, setUserBrand] = useState("");
  const [brandCampaigns, setBrandCampaigns] = useState([]);
  const [fetchingCampaigns, setFetchingCampaigns] = useState(false);

  const [noCampaigns, setNoCampaigns] = useState(false);
  const lightGray = useColorModeValue("gray.100", "gray.900");

  const userInfo = validateUserAuth();
  if (userInfo?.organization) {
    navigate("/brandCampaigns");
  } else if (!userInfo) {
    navigate("/login");
  } else if( userInfo.isAdmin){
    navigate("/admin/campaigns");
  }

  useEffect(() => {
    setFetchingCampaigns(true);

    getAllCampaigns().then((campaigns) => {
      if (campaigns.length) {
        setNoCampaigns(true);
      }
      let sortedCampaigns = campaigns.sort((a, b) => {
        return (a.disabled || false) - (b.disabled || false);
      });
      setBrandCampaigns(sortedCampaigns);
      setFetchingCampaigns(false);
    });
  }, []);

  return (
    <Grid
      templateAreas={`"header header" "main main" "footer footer"`}
      gridTemplateRows={"50px 1fr 30px"}
      gridTemplateColumns={"150px 1fr"}
      color="blackAlpha.700"
      pb="75px"
    >
      <Nav />

      <GridItem pl="2" area={"main"}>
        <Center>
          <VStack>
            <Card
              maxWidth="1200px"
              align
              mx="5"
              mt="10"
              mb="5"
              p="3"
              bg={useColorModeValue("gray.100", "gray.900")}
            >
              <Center mx="25" align="left" px="15">
                <Text fontSize="xl" as="b" mb="2">
                  Select which production company’s marketing campaign you’d
                  like to Hubit!
                </Text>
              </Center>
              <Center mx="25" align="left" px="15">
                <Text fontSize="xl" as="b" mb="2">
                  You have 8 minutes to complete any campaign.
                </Text>
              </Center>
            </Card>
            {!fetchingCampaigns && !brandCampaigns.length && (
              <Center>
                <Box>
                  <Text>There are no active campaigns left to evaluate.</Text>
                </Box>
              </Center>
            )}

            {!fetchingCampaigns && brandCampaigns.length !== 0 && (
              <Card maxWidth="1200px" mx="5" my="5" p="3" bg={lightGray}>
                <Flex m="2">
                  <Box width="100%">
                    <Heading fontSize="2xl">Available Campaigns</Heading>
                  </Box>
                </Flex>
                <SimpleGrid columns={[2, null, 3]}>
                  {brandCampaigns.map((campaign, idx) => {
                    return <CampaignCard campaign={campaign} owner={false} />;
                  })}
                </SimpleGrid>
              </Card>
            )}
          </VStack>
        </Center>
      </GridItem>

      <Footer />
    </Grid>
  );
}

export default Campaigns;
